import { useState, useEffect } from "react";
import { SEO, FrameArrayRender, Loading } from "../components";
import { useMixData } from "../hooks/useMixData";

export const Mix = (props) => {
  const { project, config } = props;
  const [loading, setLoading] = useState(true);

  const sheetId = config?.googleSheetId;
  const mixData = useMixData(sheetId);
  const seo = config?.SEO.mixes;

  useEffect(() => {
    if (mixData && mixData.length > 0) {
      setLoading(false);
    }
  }, [mixData]);

  return (
    <div id="MusicPage" className="music-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />

      {loading ? (
        <Loading />
      ) : (
        <div className="music-container">
          <FrameArrayRender data={mixData} pageTitle={"MIXES"} />
        </div>
      )}
    </div>
  );
};
